import { useCallback, useState } from 'react'
import { graphql, compose } from 'react-apollo'
import { DeleteSessionEmulation } from '~/queries/session.gql'
import PropTypes from 'prop-types'
import useToggle from '~/hooks/useToggle'
import ConfirmModal from '~/components/shared/ConfirmModal'

function Emulator ({ profile, deleteEmulation }) {
  const [modalOpen, toggleModal, setModal] = useToggle()
  const [message, setMessage] = useState('Delete emulation failed, please try again.')

  // Handle deleting emulation
  const handleClick = useCallback(async () => {
    try {
      const { data: { deleteSessionEmulation } } = await deleteEmulation()

      if (deleteSessionEmulation) {
        window.location.href = `${window.location.origin}${profile.session.emulatedDetails.fromPath}`
      } else {
        setModal(true)
      }
    } catch (error) {
      setMessage(`Delete emulation failed. ${error.message}`)
      setModal(true)
    }
  }, [profile])

  // Handle refresh page
  const handleRefresh = useCallback(() => {
    window.location.reload(false)
  })

  if (profile.session && profile.session.emulated) {
    return (
      <>
        <div className='emulator text-center cursor-pointer bg-danger text-white' onClick={handleClick}>
          <span>You're currently emulating. Click to revert.</span>
        </div>
        <ConfirmModal
          isOpen={modalOpen}
          toggle={toggleModal}
          confirm={handleRefresh}
          title='Emulation Error'
          description={message}
          text='Refresh'
          color='primary'
        />
      </>
    )
  }

  return null
}

Emulator.propTypes = {
  profile: PropTypes.object.isRequired,
  deleteEmulation: PropTypes.func
}

const withDeleteSessionEmulation = graphql(DeleteSessionEmulation, {
  name: 'deleteEmulation'
})

export default compose(
  withDeleteSessionEmulation
)(Emulator)
